

interface Client {
  id: number;
  name: string;
  logo: string;
  alt: string;
}

const ClientLogos = () => {
  const clients: Client[] = [
  {
    id: 1,
    name: 'NMB Bank',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1d30fccc1-1769287450440.png",
    alt: 'NMB Bank corporate logo in green and white colors on professional banking letterhead'
  },
  {
    id: 2,
    name: 'Tanzania Revenue Authority',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_18cc26307-1767693394679.png",
    alt: 'Tanzania Revenue Authority official emblem with national colors and government seal'
  },
  {
    id: 3,
    name: 'Air Tanzania',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_173ce7225-1769287449583.png",
    alt: 'Air Tanzania airline logo featuring stylized aircraft and Tanzanian flag colors'
  },
  {
    id: 4,
    name: 'CRDB Bank',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_15fdfd626-1768817742330.png",
    alt: 'CRDB Bank corporate identity logo in blue and gold on banking documents'
  },
  {
    id: 5,
    name: 'Tanzania Ports Authority',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_15a8cbe8b-1768312668223.png",
    alt: 'Tanzania Ports Authority maritime logo with anchor symbol and blue ocean theme'
  },
  {
    id: 6,
    name: 'Vodacom Tanzania',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1eebfb1d6-1769287448556.png",
    alt: 'Vodacom Tanzania telecommunications logo in red and white corporate branding'
  }];


  return null;
};

export default ClientLogos;